import { aytyErrorLabel, unauthorizedCode } from "consts";
import { BaseReponseType } from "models";
import { RefObject } from "react";

export const aytyFormatError = <T extends Omit<BaseReponseType, "dtServer">>(
  data: T
) => {
  if (data.idReturnAPI === unauthorizedCode) return "errors.loggedOutUser";
  else return data.deReturnAPI.replace(aytyErrorLabel, "").trim();
};

export const clearObject = (obj: Object) => {
  return Object.assign(
    {},
    ...Object.entries(obj).map(([key, value]) => {
      if (value === "" || (Array.isArray(value) && value.length === 0))
        return undefined;
      return { [key]: value };
    })
  );
};

export const exitElement =
  (ref: RefObject<HTMLElement | null>, callback?: () => void) => (e: Event) => {
    if (e.target !== ref?.current && !ref?.current?.contains(e.target as Node))
      callback?.();
  };

export const generateUID = () => {
  const numToBase16 = (num: number) => Math.floor(num).toString(16);
  return (
    numToBase16(Date.now() / 1000) +
    " ".repeat(16).replace(/./g, () => numToBase16(Math.random() * 16))
  );
};

export * from "./mask";
export * from "./schemas";
